export default __webpack_public_path__ + "static/img/ticket-male.f3cbacc.png";